import { SET_BRUSH_TIMESTAMPS } from '../../../../../actions/chart';

export default (state = null, action) => {
  switch (action.type) {
    case SET_BRUSH_TIMESTAMPS:
      return action.payload.startTimestamp;
    default:
      return state;
  }
};

export const getStartTimestamp = state => state;